<template>
  <div class="login-page">
    <div class="login-container">
      <!-- Logo 和标题 -->
      <img src="@/assets/login_logo.png" alt="logo" class="logo" />
      <h1 class="login_title">Welcome to HDAPI backend System</h1>
      <el-form :model="loginForm" @submit.prevent="onLogin">
        <!-- 用户名输入框 -->
        <span class="text_tig">userName</span>
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            class="custom-input"
          ></el-input>
        </el-form-item>

        <!-- 密码输入框 -->
        <span class="text_tig">password</span>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            class="custom-input"
            type="password"
          ></el-input>
        </el-form-item>
        <span class="text_tig">Graphic verification code</span>
        <el-form-item prop="caches">
          <div class="caches-row">
            <el-input v-model="loginForm.code" class="custom-caches" />
            <img
              :src="captchaUrl"
              class="captcha-img"
              @click="getCaptchaImageFn"
            />
          </div>
        </el-form-item>
        <!-- 登录按钮 -->
        <el-form-item>
          <el-button class="login-button" @click="onLogin"> Log in </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { httpLogin, getCaptchaImage, getUserInfo } from "@/api/loginApi";
import {
  setToken,
  setUserName,
  setUserInfoList,
  setCurrentUser,
} from "@/stores/auth";
const captchaUrl = ref("");

const loginForm = ref({
  username: "",
  password: "",
  code: "",
  uuid: "",
});

const router = useRouter();

const onLogin = async () => {
  try {
    const response = await httpLogin(loginForm.value);
    if (response.code === 200) {
      setToken(response.token); // 存储 Token
      setUserName(loginForm.value.username);
      fetchUserInfo();
    } else {
      getCaptchaImageFn();
      ElMessage.error(response.msg); // 处理失败消息
    }
  } catch (error) {
    ElMessage.error(error);
  }
};
// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await getUserInfo();
    if (response.code === 200) {
      const list = response.data;
      // 存储用户列表
      setUserInfoList(list);
      setCurrentUser(list[0]);
      //currentUser.value = list[0].merchantName;
      router.push("/dashboard");
    } else {
      ElMessage.error(response.msg);
    }
  } catch (error) {
    ElMessage.error(error);
  }
};

const getCaptchaImageFn = async () => {
  try {
    const response = await getCaptchaImage();
    if (response.code === 200) {
      // 拼接 base64 图片
      captchaUrl.value = `data:image/jpeg;base64,${response.img}`;
      loginForm.value.uuid = response.uuid; // 记得保存 uuid，后端校验要用
    } else {
      ElMessage.error(response.msg);
    }
  } catch (error) {
    ElMessage.error(error);
  }
};
onMounted(() => {
  getCaptchaImageFn();
});
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f7f8;
  height: 100svh;
}
.login_title {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 600;
  font-style: Semibold;
  font-size: 30px;
  line-height: 100%;
  color: #333333;
  margin-top: 32px;
  max-width: 424px;
}
.login-container {
  padding: 48px;
  background: #ffffff;
  border-radius: 24px;
}

.logo {
  width: 154.47px;
  height: 32px;
}

.text_tig {
  margin-top: 24px;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: -0.31px;
}
.el-form-item {
  margin-bottom: 27px; /* 默认值，可能是 20px 或 24px，视版本而定 */
}
.login-button {
  width: 424px;
  height: 56px;
  background: #8e67ea;
  border: none;
  color: #ffffff;
  border-radius: 12px;
  font-size: 16px;
}
.login-button:hover {
  background-color: #8e67ea;
  color: #ffffff;
  font-size: 16px;
}
.custom-input {
  width: 424px;
  height: 56px;
  margin-top: 8px;
  --el-input-focus-border-color: #8e67ea;
}
.custom-caches {
  height: 56px;
  flex: 6;
  margin-top: 8px;
  --el-input-focus-border-color: #8e67ea;
}
::v-deep(.el-input__inner) {
  color: #333333;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: -0.31px;
}
::v-deep .el-input__wrapper {
  border-radius: 12px; /* 设置圆角 */
}
.caches-row {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.captcha-img {
  flex: 4;
  height: 56px;
  border-radius: 12px;
  object-fit: cover;
  cursor: pointer;
}
</style>
